enum RoundingDirection {
  NONE = 'NONE',
  FORWARD = 'FORWARD',
  BACKWARD = 'BACKWARD'
}

export default RoundingDirection;
